
import {akShareSignature} from '@/api/common.js';
import wx from 'weixin-js-sdk';	// 使用js-sdk

export class WxShare {

    signMap = new Map();  // 存储地址url认证信息sign

    // 分享默认参数
    defaultShareConfig = {
        title: '居延国旅',
        desc: '居延国旅',
        link: location.href,
        imgUrl: '',
        jsApiList: [ 'updateAppMessageShareData', 'updateTimelineShareData' ],
    }

    // 分享参数
    wxShareConfig = {}

    // 测试方法
    log(val) {
        console.log('this is share', val)
        console.log('defaultShareConfig', this.defaultShareConfig)
    }

    /**
     *
     * @param {Object} config 分页配置信息，包括title，desc，等等；
     */
    wxShare( config = {}) {
        this.wxShareConfig.title = config.title || this.defaultShareConfig.title;
        this.wxShareConfig.desc = config.desc || this.defaultShareConfig.desc;
        this.wxShareConfig.link = config.link || this.defaultShareConfig.link;
        this.wxShareConfig.imgUrl = config.imgUrl || this.defaultShareConfig.imgUrl;
        this.wxShareConfig.jsApiList = config.jsApiList || this.defaultShareConfig.jsApiList;

        // 如果 imgUrl 包含中文字符，进行编码
        if (this.wxShareConfig.imgUrl && /[\u4e00-\u9fa5]/.test(this.wxShareConfig.imgUrl)) {
            try {
                const urlObj = new URL(this.wxShareConfig.imgUrl);
                // 只对 path 中的中文部分编码，保持域名不变
                const encodedPath = urlObj.pathname.split('/').map(p => encodeURIComponent(p)).join('/');
                this.wxShareConfig.imgUrl = urlObj.origin + encodedPath + urlObj.search + urlObj.hash;
            } catch(e) {
                // URL 解析失败则保持原样
            }
        }

        const signMsg = this.signMap.get(this.wxShareConfig.link)
        if(signMsg) {
            // 注入签名信息， 并调用分享
            this.injectAndShare(signMsg)
        } else {
            // 当前分享链接不存在签名 = 更新签名信息
            // 获取签名信息
            this.getShareAuth(this.wxShareConfig.link)
        }
    }


    /**
     *
     * @param {Object} signMsg 接口签名信息
     * @desc jssdk签名权限注入，并添加分享事件监听器
     */
    injectAndShare(signMsg) {

        const that = this;

        signMsg.timestamp = signMsg.timestamp.toString();

        // 访问页面和获取页面必须保持一致
        wx.config({
            debug: false,  // 生产环境关闭
            appId: signMsg.appId,
            timestamp: signMsg.timestamp,   // 注意！时间戳这里应该是10位字符串
            nonceStr: signMsg.nonceStr,     // 注意驼峰命名
            signature: signMsg.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
        })
        wx.ready(function() {
            const { title,desc,link,imgUrl } = that.wxShareConfig;

            wx.checkJsApi({
              jsApiList:  ['updateAppMessageShareData', 'updateTimelineShareData'],
              success: function(res) {
              },
                fail: function(e) {
                }
            });

            wx.updateAppMessageShareData({
                title,desc,link,imgUrl,
                success: function() {
                },
                cancel: function() {
                },
                fail: function(err) {
                }
            })

            // 注意：updateTimelineShareData 不支持 desc 参数！
            wx.updateTimelineShareData({
                title, link, imgUrl,
                success: function() {
                },
                cancel: function() {
                },
                fail: function() {
                }
            })


            // 注意：新旧接口不能混用！只保留新接口即可。
            // 旧接口 onMenuShareAppMessage / onMenuShareTimeline 已废弃，混用会导致配置失效

        })

        wx.error(function(res) {
            console.log('wx error:', res)
        })

    }

    /**
     *
     * @param {url} shareUrl
     * @description 从服务器获取分享页面签名信息
     */
    getShareAuth(shareUrl) {

        akShareSignature({
            shareUrl: shareUrl
        }).then((res) => {
            this.signMap.set(shareUrl, res)  // 存储信息
            this.injectAndShare(res);  // 注入签名信息
        })

    }
}
